/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Radio = require('backbone.radio');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');
var PrinterView = require('common/views/PrinterView');

var ConSerComplaintFormForPrintingView = require('../views/ConSerComplaintFormForPrintingView');

// var GetExternalComplaint = require('../../complaint-form/services/GetExternalComplaint');
var GetComplaint = require('../services/GetComplaint');
var GetAllComplaintLookups = require('../services/GetAllComplaintLookups');

module.exports = function(complaintId) {
  NProgress.start();
  NProgress.set(0.3);

  $.when(GetComplaint(complaintId), GetAllComplaintLookups())
    .done(function(complaint, lookups) {
      NProgress.set(0.7);
      NavUtils.navigate('conser/complaint/' + complaintId + '/print');

      Radio.channel('header').trigger('hide:header');
      Radio.channel('footer').trigger('hide:footer');

      var conSerComplaintFormForPrintingView = new ConSerComplaintFormForPrintingView({
        model: new Backbone.Model({
          complaintId: complaintId,
          complaint: complaint,
          complaintIssues: lookups.complaintIssues
        }),
        isReadOnly: true,
        mode: 'print',
        showRequiredFieldDisclaimer: false
      });
      Scaffold.content.show(
        new PrinterView({
          viewToPrint: conSerComplaintFormForPrintingView
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
